import { render, staticRenderFns } from "./HoldsSong.vue?vue&type=template&id=18d501be"
import script from "./HoldsSong.vue?vue&type=script&lang=js"
export * from "./HoldsSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports